<template>
<div>
    <Breadcrumbs main="Admin" submain="Subscription" title="Wallet History" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div style="display: flex; flex-direction: column;">
                            <!-- <h7>{{ history?.user?.username }}</h7> -->
                            <h7>{{ history?.user?.email }}</h7>
                            <h7 style="display: flex; align-items: center; gap: 10px; text-align: center;"><span style="color: #3f3838; font-size: small;">Wallet Balance:</span> <span class="badge badge-pill badge-secondary" style="max-width: fit-content; color: white;">{{ history?.user?.wallet_balance }}</span></h7>
                        </div>
                    </div>
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="history.history" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(description)="row">
                                        <div v-if="row.item.description" style="max-width: 440px;">
                                            <h7>{{ row.item.description }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(coin_cost)="data">
                                        <span :class="{ 'highlight': data.item.coin_cost > 0 }">
                                            {{ data.item.coin_cost }}
                                        </span>
                                    </template>

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'coin_cost',
                    label: 'Cost',
                    sortable: true
                },
    
                {
                    key: 'created_on',
                    label: 'Created On',
                    sortable: true
                }
            ],

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [20, 30, 50]
        };
    },

    computed: {
        ...mapState({
            history: state => state.subscriber.history,
            loading: state => state.subscriber.historyLoading,
            error: state => state.subscriber.historyError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        console.log(this.$route.query.user_id)
        this.$store.dispatch("subscriber/fetchHistory", this.$route.query.user_id).then(() => {
            this.items = this.history?.history
            this.totalRows = this.history?.history?.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    }
};
</script>

<style scoped>
    .highlight {
        background-color: #26216311;
        font-weight: bold;
        color: #262163;
        padding: 8px;
        border-radius: 4px;
    }
</style>
